import type { PromoCodeState } from "../checkoutPromoTypes";

type Formatters = {
  formatCurrency: (value: number) => string;
  formatPercentage: (value: number) => string;
};

export function getPromoAppliedMessage(
  promo: Pick<PromoCodeState, "discountType" | "discountValue" | "discount">,
  { formatCurrency, formatPercentage }: Formatters
): string {
  if (promo.discountType === "freeShipping") {
    return "Pacote gratuito — 100% de desconto";
  }
  if (promo.discountType === "fixedAmount" && promo.discountValue !== undefined) {
    return `Desconto de ${formatCurrency(promo.discountValue)} aplicado`;
  }
  if (promo.discount > 0) {
    return `Desconto de ${formatPercentage(promo.discount)} aplicado`;
  }
  return "Cupom aplicado";
}
